import React, { useEffect } from 'react';
import { useTranslations } from 'hooks/useTranslations';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { ERouteLinks } from 'models/route';
import { StyledPageTitle } from 'theme/styles';
import { useAlert } from 'models/alertContext';
import { ActionTypes } from 'state/actions/alert';
import { Box, Grid } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Elabels, getBreadcrumbsBasic } from 'pages/CaseManagementPage/CasesPage/helpers';
import FormIntelligenceReport from '../FormIntelligenceReport';
import { IReportResultFormValue } from 'models/cases';
import { Alert } from 'components/atoms/Alert';
import { useCase } from 'pages/CaseManagementPage/CasesPage/hooks';
import { isPathEqualToRouteName } from 'utils/route';
import { useQuery } from 'hooks/useQuery';

const AddIntelligenceReport = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const type: string | null = query.get('type')?.trim() || null;
  const {
    id = '',
    caseId = '',
    reportId = '',
  } = useParams<{ id: string; caseId: string; reportId: string }>();
  const { t } = useTranslations();
  const { clearAlert, samePageAlert } = useAlert();
  const { addReportResult } = useCase();
  const { pathname }: any = useLocation();
  const isFromLE = isPathEqualToRouteName(
    pathname,
    ERouteLinks.LegalEntityAddIntelligenceReportResult,
  );
  const breadcrumbs = getBreadcrumbsBasic(isFromLE, type, t, false, id);

  useEffect(
    () => () => {
      clearAlert(ActionTypes.CLEAR_SAME_PAGE_ALERT);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const submitForm = async (data: IReportResultFormValue) => {
    const res = await addReportResult(reportId, data);
    if (res) {
      isFromLE
        ? navigate(
            `${ERouteLinks.LegalEntityCasesDetailsPage.replace(':caseId', caseId).replace(
              ':id',
              id,
            )}?type=${type}&expand=cases`,
          )
        : navigate(ERouteLinks.CasesDetailsPage.replace(':caseId', caseId));
    }
  };

  return (
    <>
      <Breadcrumbs
        items={[
          ...breadcrumbs,
          {
            label: t(Elabels.caseDetailsHeader),
            route: isFromLE
              ? `${ERouteLinks.LegalEntityCasesDetailsPage.replace(':caseId', caseId).replace(':id', id)}?type=${type}&expand=cases`
              : `${ERouteLinks.CasesDetailsPage.replace(':caseId', caseId)}`,
          },
          t(Elabels.addResults),
        ]}
      />
      <Grid sx={{ alignItems: 'center' }}>
        <StyledPageTitle variant="h4">{t(Elabels.addResults)}</StyledPageTitle>
      </Grid>
      {samePageAlert && (
        <Box sx={{ mt: 2, mb: 2 }}>
          <Alert text={samePageAlert.text} variant={samePageAlert.variant} />
        </Box>
      )}
      <FormIntelligenceReport
        onSubmit={submitForm}
        prevLink={
          isFromLE
            ? `${ERouteLinks.LegalEntityCasesDetailsPage.replace(':caseId', caseId).replace(':id', id)}?type=${type}&expand=cases`
            : `${ERouteLinks.CasesDetailsPage.replace(':caseId', caseId)}`
        }
      />
    </>
  );
};

export default AddIntelligenceReport;
